import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { ROUTES } from 'routes';

const RoutesView = () => {
  return (
    <Routes>
      {ROUTES.map(({ path = '', ...rest }) => (
        <Route key={path} path={path} {...rest} />
      ))}
    </Routes>
  );
};

export default RoutesView;
